import { render, staticRenderFns } from "./VDrawer.vue?vue&type=template&id=a4799c84&scoped=true&"
import script from "./VDrawer.vue?vue&type=script&lang=js&"
export * from "./VDrawer.vue?vue&type=script&lang=js&"
import style0 from "./VDrawer.vue?vue&type=style&index=0&id=a4799c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4799c84",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VDrawerMenu: require('/app/components/layouts/drawer/VDrawerMenu.vue').default})
